// Mock/real data for Pahala Digital member area.
// NOTE: Google Drive folder links below are the REAL links provided by the owner.

export const MEMBER_CREDENTIALS = {
  email: '123@gmail.com',
  password: 'jamban123',
  name: 'Project Log',
};

export const ADMIN_CREDENTIALS = {
  email: 'admin@pahala.com',
  password: 'admin123',
  username: 'ihsanfatahilah',
};

export const footageContent = [
  { id: 'f1', label: 'FILE #1', title: 'Konten Footage 1', url: 'https://drive.google.com/drive/folders/12TC2mZioBPkBWcwQjcl2lfvQe0QSb9f1?usp=drive_link' },
  { id: 'f2', label: 'FILE #2', title: 'Konten Footage 2', url: 'https://drive.google.com/drive/folders/1iitm2YPJGLfeEbSDam2CQ7ckUjDRPoXc?usp=drive_link' },
  { id: 'f3', label: 'FILE #3', title: 'Konten Footage 3', url: 'https://drive.google.com/drive/folders/1PnPufXGscByKZkfUGdCvSaugqsYW4_TE?usp=drive_link' },
];

export const islamicContent = [
  { id: 'i1', label: 'FILE #1', title: 'Konten Islamic 1', url: 'https://drive.google.com/drive/folders/1qAuX3NWwESdnquPwuNDSIjsbS_hMwF79?usp=drive_link' },
  { id: 'i2', label: 'FILE #2', title: 'Konten Islamic 2', url: 'https://drive.google.com/drive/folders/1qAuX3NWwESdnquPwuNDSIjsbS_hMwF79?usp=drive_link' },
  { id: 'i3', label: 'FILE #3', title: 'Konten Islamic 3', url: 'https://drive.google.com/drive/folders/19UIsd_HnQyj6uRrhONK_uV5lrON2wGjA?usp=drive_link' },
  { id: 'i4', label: 'FILE #4', title: 'Konten Islamic 4', url: 'https://drive.google.com/drive/folders/19UIsd_HnQyj6uRrhONK_uV5lrON2wGjA?usp=drive_link' },
  { id: 'i5', label: 'FILE #5', title: 'Konten Islamic 5', url: 'https://drive.google.com/drive/folders/1KoE5chGdUDxVjcvOXilPwnYA1jM3EMmz?usp=drive_link' },
  { id: 'i6', label: 'FILE #6', title: 'Konten Islamic 6', url: 'https://drive.google.com/drive/folders/19UIsd_HnQyj6uRrhONK_uV5lrON2wGjA?usp=sharing' },
];

export const bonusContent = [
  { id: 'b1', title: 'Canva Ucapan Lebaran', url: 'https://drive.google.com/drive/folders/1hI4F-FTvxImP50LFbSjddIUAz_QIAWQq' },
  { id: 'b2', title: '500+ Template Desain Islami', url: 'https://drive.google.com/drive/folders/1gAOsBjVpdcilMLoRTDaDvC98nl_5veoD' },
  { id: 'b3', title: 'Kumpulan Kisah Islami Penuh Hikmah', url: 'https://drive.google.com/drive/folders/1JcK6t765zs09JhFBUtPVy8F3oegVGOVG' },
  { id: 'b4', title: "Murottal (Bacaan Al-Qur'an Merdu)", url: 'https://drive.google.com/drive/folders/1HLxKKFP4OZ3IRIeRLlp5-J9jfcsAHPN-' },
  { id: 'b5', title: 'Lagu Anak Islami', url: 'https://drive.google.com/drive/folders/1NjgrM0DWvNFuTybeG8osSckgw-l6Au5q' },
  { id: 'b6', title: 'Vid Story WhatsApp', url: 'https://drive.google.com/drive/folders/1-9fC_DK6OTolMjlf-p4U0YDXEu145-3N' },
  { id: 'b7', title: 'Bonus 10+ Konten Berbagai Niche & Bonus Lainnya', url: 'https://forms.gle/ro8iwyBXNRnmiFWy7' },
];

export const classesContent = [
  { id: 'c1', title: 'KELAS HASILKAN DOLAR DI FB PRO', url: 'https://belajarpenghasilan.my.id/pro-5/' },
  { id: 'c2', title: 'KELAS HASILKAN CUAN DI YT SHORTS', url: 'https://belajarcuandiyt.my.id/shorts99/' },
];

export const perhatianText = [
  'Untuk penggunaan komersial seperti di Facebook Pro dan YouTube Shorts, sebaiknya video mengalami sedikit penyesuaian terlebih dahulu \u2014 misalnya dengan mengganti musik latar atau menambahkan efek suara baru.',
  'Langkah ini membantu agar algoritma platform mengenali konten sebagai materi yang \u201cfresh\u201d sehingga peluang jangkauan dan performa videonya bisa lebih optimal.',
];

export const caraInstal = [
  'Install dulu Google Drive untuk memudahkan proses download.',
  'Pastikan membuka & download dengan akun yang sama (email = akun Google Drive).',
  'Jika folder kosong, refresh dulu dan tunggu proses loading sampai muncul semua (waktu transfer data tergantung kecepatan internet).',
  'File ini sebaiknya didownload dan disimpan di memory HP/PC (ditakutkan file error dan tidak bisa dibuka lagi).',
];

export const heroImage = 'https://images.unsplash.com/photo-1581141444721-0e6f8fa8397e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600';

// Seed mitra (as shown in admin panel screenshot)
export const seedMitra = [
  {
    id: 'm1',
    name: 'Project Log',
    email: '123@gmail.com',
    phone: '089654155652',
    password: 'jamban123',
    status: 'aktif', // menunggu | aktif | ditolak
    createdAt: '2026-01-01T00:00:00.000Z',
  },
];
